// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Filter toolbar shown above every paged table.  Single-row layout — search,
   time filter, date controls and reset all sit on one horizontal line. */
.ttb {
  background: var(--n-0);
  border: 1px solid var(--n-200);
  border-radius: var(--radius-xl);
  padding: 8px 12px;
  margin: 10px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.ttb-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1 100%;
}

.ttb-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--n-500);
  padding-right: 2px;
}

.ttb-toggle {
  display: flex;
  background: var(--n-100);
  border-radius: var(--radius-lg);
  padding: 4px;
  border: 1px solid var(--n-200);
}
.ttb-toggle-btn {
  padding: 6px 14px;
  border: none;
  background: transparent;
  color: var(--n-500);
  font-size: 12px;
  font-weight: 600;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--dur-base) ease;
  font-family: inherit;
}
.ttb-toggle-btn:hover:not(.is-active) { color: var(--n-900); }
.ttb-toggle-btn.is-active {
  background: var(--clr-accent);
  color: var(--n-0);
}

.ttb-date {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--n-50);
  border: 1px solid var(--n-200);
  border-radius: var(--radius-lg);
  padding: 4px 8px;
}
.ttb-date-range { padding: 4px 10px; }
.ttb-nav-btn {
  width: 26px;
  height: 26px;
  border: none;
  background: transparent;
  color: var(--n-600);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  border-radius: var(--radius-sm);
}
.ttb-nav-btn:hover { background: var(--n-200); color: var(--n-900); }
.ttb-date-input {
  padding: 6px 8px;
  border: 1px solid var(--n-300);
  border-radius: var(--radius-md);
  background: var(--n-0);
  font-size: 12px;
  color: var(--n-900);
  font-family: inherit;
  cursor: pointer;
}
.ttb-date-label {
  font-size: 12px;
  color: var(--n-900);
  font-weight: 600;
  padding: 0 6px;
}
.ttb-sub {
  font-size: 11px;
  font-weight: 600;
  color: var(--n-600);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.ttb-today {
  padding: 6px 12px;
  background: var(--clr-accent);
  color: var(--n-0);
  border: none;
  border-radius: var(--radius-md);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}
.ttb-today:hover { background: var(--clr-accent-hover); }

.ttb-search {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--n-50);
  border: 1px solid var(--n-200);
  border-radius: var(--radius-md);
  padding: 4px 10px;
  flex: 0 1 240px;
  min-width: 180px;
  height: 32px;
}
.ttb-search-icon { font-size: 13px; color: var(--n-500); }
.ttb-search-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  outline: none;
  font-size: 12px;
  color: var(--n-900);
  font-family: inherit;
}

.ttb-reset {
  margin-left: auto;
  padding: 6px 12px;
  background: var(--n-0);
  border: 1px solid var(--n-300);
  color: var(--n-600);
  border-radius: var(--radius-md);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  height: 32px;
  white-space: nowrap;
}
.ttb-reset:hover {
  background: var(--danger-50);
  border-color: var(--danger-200);
  color: var(--danger-600);
}

/* Make every control inside the toolbar share the same compact height */
.ttb-toggle { padding: 2px; }
.ttb-toggle-btn { padding: 6px 12px; font-size: 12px; }
.ttb-label { font-size: 11px; }
.ttb-nav-btn { width: 24px; height: 24px; font-size: 11px; }
.ttb-date { padding: 4px 6px; gap: 4px; }
.ttb-date-input { padding: 4px 8px; font-size: 12px; }
.ttb-today { padding: 6px 12px; font-size: 12px; height: 32px; }

@media (max-width: 1024px) {
  .ttb-reset { margin-left: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/common/TableToolbar.css"],"names":[],"mappings":"AAAA;yEACyE;AACzE;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,+BAA+B;EAC/B,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,oCAAoC;EACpC,oBAAoB;AACtB;AACA,wCAAwC,mBAAmB,EAAE;AAC7D;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA,kBAAkB,iBAAiB,EAAE;AACrC;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;AACA,qBAAqB,wBAAwB,EAAE,mBAAmB,EAAE;AACpE;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA,mBAAmB,mCAAmC,EAAE;;AAExD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA,mBAAmB,eAAe,EAAE,mBAAmB,EAAE;AACzD;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,wEAAwE;AACxE,cAAc,YAAY,EAAE;AAC5B,kBAAkB,iBAAiB,EAAE,eAAe,EAAE;AACtD,aAAa,eAAe,EAAE;AAC9B,eAAe,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;AAC3D,YAAY,gBAAgB,EAAE,QAAQ,EAAE;AACxC,kBAAkB,gBAAgB,EAAE,eAAe,EAAE;AACrD,aAAa,iBAAiB,EAAE,eAAe,EAAE,YAAY,EAAE;;AAE/D;EACE,aAAa,cAAc,EAAE;AAC/B","sourcesContent":["/* Filter toolbar shown above every paged table.  Single-row layout — search,\n   time filter, date controls and reset all sit on one horizontal line. */\n.ttb {\n  background: var(--n-0);\n  border: 1px solid var(--n-200);\n  border-radius: var(--radius-xl);\n  padding: 8px 12px;\n  margin: 10px 0;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.ttb-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1 1 100%;\n}\n\n.ttb-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--n-500);\n  padding-right: 2px;\n}\n\n.ttb-toggle {\n  display: flex;\n  background: var(--n-100);\n  border-radius: var(--radius-lg);\n  padding: 4px;\n  border: 1px solid var(--n-200);\n}\n.ttb-toggle-btn {\n  padding: 6px 14px;\n  border: none;\n  background: transparent;\n  color: var(--n-500);\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all var(--dur-base) ease;\n  font-family: inherit;\n}\n.ttb-toggle-btn:hover:not(.is-active) { color: var(--n-900); }\n.ttb-toggle-btn.is-active {\n  background: var(--clr-accent);\n  color: var(--n-0);\n}\n\n.ttb-date {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--n-50);\n  border: 1px solid var(--n-200);\n  border-radius: var(--radius-lg);\n  padding: 4px 8px;\n}\n.ttb-date-range { padding: 4px 10px; }\n.ttb-nav-btn {\n  width: 26px;\n  height: 26px;\n  border: none;\n  background: transparent;\n  color: var(--n-600);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n}\n.ttb-nav-btn:hover { background: var(--n-200); color: var(--n-900); }\n.ttb-date-input {\n  padding: 6px 8px;\n  border: 1px solid var(--n-300);\n  border-radius: var(--radius-md);\n  background: var(--n-0);\n  font-size: 12px;\n  color: var(--n-900);\n  font-family: inherit;\n  cursor: pointer;\n}\n.ttb-date-label {\n  font-size: 12px;\n  color: var(--n-900);\n  font-weight: 600;\n  padding: 0 6px;\n}\n.ttb-sub {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--n-600);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.ttb-today {\n  padding: 6px 12px;\n  background: var(--clr-accent);\n  color: var(--n-0);\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n.ttb-today:hover { background: var(--clr-accent-hover); }\n\n.ttb-search {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--n-50);\n  border: 1px solid var(--n-200);\n  border-radius: var(--radius-md);\n  padding: 4px 10px;\n  flex: 0 1 240px;\n  min-width: 180px;\n  height: 32px;\n}\n.ttb-search-icon { font-size: 13px; color: var(--n-500); }\n.ttb-search-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 12px;\n  color: var(--n-900);\n  font-family: inherit;\n}\n\n.ttb-reset {\n  margin-left: auto;\n  padding: 6px 12px;\n  background: var(--n-0);\n  border: 1px solid var(--n-300);\n  color: var(--n-600);\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n  height: 32px;\n  white-space: nowrap;\n}\n.ttb-reset:hover {\n  background: var(--danger-50);\n  border-color: var(--danger-200);\n  color: var(--danger-600);\n}\n\n/* Make every control inside the toolbar share the same compact height */\n.ttb-toggle { padding: 2px; }\n.ttb-toggle-btn { padding: 6px 12px; font-size: 12px; }\n.ttb-label { font-size: 11px; }\n.ttb-nav-btn { width: 24px; height: 24px; font-size: 11px; }\n.ttb-date { padding: 4px 6px; gap: 4px; }\n.ttb-date-input { padding: 4px 8px; font-size: 12px; }\n.ttb-today { padding: 6px 12px; font-size: 12px; height: 32px; }\n\n@media (max-width: 1024px) {\n  .ttb-reset { margin-left: 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
